const initialState = {
  error: null
}

export const SET_ERROR = 'SET_ERROR'
export const CLEAR_ERROR = 'CLEAR_ERROR'

export function setError(error) {
  return {
    type: SET_ERROR,
    error
  }
}

export function clearError() {
  return {
    type: CLEAR_ERROR
  }
}

const ACTION_HANDLERS = {
  [SET_ERROR]: (state, { error }) => ({ ...state, error}),
  [CLEAR_ERROR]: () => (initialState)
}

export default function errorReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]

  return handler ? handler(state, action) : state
}